import React, { Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { TableRow, TableCell, Tooltip, Chip } from '@material-ui/core';
import folderIcon from '../../../assets/images/folder_icon.svg'
import techSpecIcon from '../../../assets/images/tech_specs_icon.svg'
import dataRmIcon from '../../../assets/images/data_rm_icon.svg'
import priorityActiveIcon from '../../../assets/images/priority_active_icon.svg'
import priorityInactiveIcon from '../../../assets/images/priority_inactive_icon.svg'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { checkPermission, getFileSize, getLocalStorageInfo } from '../../../utils';
import { assetTypeValues } from '../../../constants';
import {trackActivity} from '../../../utils/mixpanel'
import config from '../../../config';
const AssetList = ({item,props, changeOCRPriorityAsset}) => {
  const avolonInstance = getLocalStorageInfo()?.defaultLessor?.id === 470
  return(

    <TableRow hover tabIndex={-1}>
      <TableCell className="asset-info" width="180">
        <div className="flex-centered">
          <img className="folder-icon" src={folderIcon} alt="Folder Icon" />
          <div className="asset">
            {(item.asset_type === 1 || item.asset_type === 2 || item.asset_type === 3) ?
              <p>
                { item.asset_type === 1 ? item.aircraft_type?.name : item.engine_type?.name }{ item.asset_type === 3 ? item.apu_type?.name : '' }
              </p>:null
            }
            <h5>
              {assetTypeValues[item.asset_type].label ? assetTypeValues[item.asset_type].label: ''} {item.asset_name}
            </h5>
            {
              props?.location?.pathname.includes('/archived-assets')?
              null:
              item?.archive_status==true?
              <span className='archive-chip-class'> Archive </span>: null
            }
            { item.current_registration_number ?
              <span style={{fontSize:'11px'}}><b>Reg. No.</b> {item.current_registration_number ? item.current_registration_number:''}</span>:null
            }

          </div>
        </div>
      </TableCell>
      <TableCell>{item.records_details && item.records_details.files_count ? item.records_details.files_count:'--'}</TableCell>
      <TableCell>{item.records_details && item.records_details.files_size ? getFileSize(item.records_details.files_size):'--'}</TableCell>
      <TableCell>{item.records_details && item.records_details.files_inqueue ? item.records_details.files_inqueue:'--'}</TableCell>
      <TableCell>{item.records_details && item.records_details.files_ocr_inqueue ? item.records_details.files_ocr_inqueue:'--'}</TableCell>
      <TableCell>{item.records_details && item.records_details.files_to_be_renamed ? item.records_details.files_to_be_renamed:'--'}</TableCell>
      <TableCell>
        <ul className="list-inline flex-centered">
          <li className="list-inline-item">
            <Tooltip title="Technical Specification"  arrow
             onClick={() => trackActivity('Item Clicked',
             {
                page_title: 'Asset Listing',
                event_desc: 'Clicked Tech Specs icon from Action in Asset listing'
             })}>
              <a href={`${config.domain.subDomian}technical-specification/${assetTypeValues[item.asset_type].urlType}/${item.slug}${item?.archive_status==true? '?archived-assets':'' }`} target="_blank"><img src={techSpecIcon} alt="Tech Specs" /></a>
            </Tooltip>
          </li>
          { item.record_folders.technical_records && item.record_folders.technical_records.uuid ?
            <li className="list-inline-item">
              {
                avolonInstance ?
                <Link to={ props.location.pathname.includes('archived-assets')|| item?.archive_status==true  ? `/${assetTypeValues[item.asset_type].urlType}/${item.slug}/data-room/${item?.record_folders.technical_records?.key_word}/${item.record_folders.technical_records.uuid}?archived-assets`   :`/${assetTypeValues[item.asset_type].urlType}/${item.slug}/data-room/${item?.record_folders.technical_records?.key_word}/${item.record_folders.technical_records.uuid}` }>
                <Tooltip title="Data Room" arrow
                 onClick={() => trackActivity('Item Clicked',
                  {
                   page_title: 'Asset Listing',
                   event_desc: 'Clicked Data room icon from Action in Asset listing'
                  })}>
                  <img src={dataRmIcon} alt="data room" />
                </Tooltip>
              </Link> :

              <Link to={ props.location.pathname.includes('archived-assets')|| item?.archive_status==true  ? `/${assetTypeValues[item.asset_type].urlType}/${item.slug}/data-room/technical/${item.record_folders.technical_records.uuid}?archived-assets`   :`/${assetTypeValues[item.asset_type].urlType}/${item.slug}/data-room/technical/${item.record_folders.technical_records.uuid}` }>
                <Tooltip title="Data Room" arrow
                 onClick={() => trackActivity('Item Clicked',
                  {
                   page_title: 'Asset Listing',
                   event_desc: 'Clicked Data room icon from Action in Asset listing'
                  })}>
                  <img src={dataRmIcon} alt="data room" />
                </Tooltip>
              </Link>
}
            </li>:null
          }
          { item.records_details && item.records_details.files_count && item.records_details.files_count > 0 && checkPermission('records','data_room','OCR_P') ?
            <li className="list-inline-item">
              <Tooltip title="Change OCR Priority" arrow
               onClick={() => trackActivity('Item Clicked',
               {
                  page_title: 'Asset Listing',
                  event_desc: 'Clicked OCR priority icon from Action in Asset listing'
               })}>
                { item.ocr_priority === 4 ?
                  <img onClick={() => changeOCRPriorityAsset()} src={priorityInactiveIcon} alt="priority" />:
                  <img onClick={() => changeOCRPriorityAsset()} src={priorityActiveIcon} alt="priority" />
                }
              </Tooltip>
            </li>:null
          }
        </ul>
      </TableCell>
    </TableRow>
  )
}
export default AssetList;
